export function isValidEmail(email: string, invalidExp?: string) {
   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   const mailIsValid = re.test(String(email).toLowerCase());
   if (invalidExp) {
      const invalidExpObj = new RegExp(invalidExp)
      return mailIsValid && !invalidExpObj.test(String(email).toLowerCase())
   } else {
      return mailIsValid
   }
}
